export enum UserStatuses {
  Active = "active",
  Pending = "pending",
}
